var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useReducer } from "react";
import { sendRequest } from "src/common/http";
import { AppContext } from "src/contexts/AppContext";
import ApiError from "src/features/common/elements/ApiError";
import WidgetLoader from "src/features/common/elements/WidgetLoader";
import translate from "src/i18n/translate";
var defaultAction = {
    type: "",
    courseEvaluationResults: null
};
var reducer = function (state, action) {
    switch (action.type) {
        case "setCourseEvaluationResults":
            return __assign(__assign({}, state), { courseEvaluationResults: action.courseEvaluationResults, showLoader: false });
        case "setCourseEvaluationResultsError":
            return __assign(__assign({}, state), { courseEvaluationResultsError: true, showLoader: false });
        default:
            return state;
    }
};
var initialState = {
    courseEvaluationResults: null,
    courseEvaluationResultsError: false,
    showLoader: true
};
export function RecentCourseEvaluation() {
    var _a = useReducer(reducer, initialState), state = _a[0], dispatch = _a[1];
    var sysUser = useContext(AppContext).sysUser;
    useEffect(function () {
        var applyResult = function (result) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setCourseEvaluationResults", courseEvaluationResults: result }));
        };
        var onError = function () {
            dispatch(__assign(__assign({}, defaultAction), { type: "setCourseEvaluationResultsError" }));
        };
        sendRequest({ uri: "/ces/recent-course-evaluation", camelize: true }, applyResult, onError);
    }, []);
    var navigateToExternalTask = function (url) {
        window.location.href = url;
    };
    var handleKeyPressFs = function (event, url) {
        if (event.key === " " || event.key === "Enter") {
            navigateToExternalTask(url);
        }
    };
    return ((state.courseEvaluationResults && state.courseEvaluationResults.length > 0) && (_jsx("div", { className: "recent-course-evaluation-container", children: _jsxs("div", { className: "widget-card recent-course-evaluation-container paper-card", children: [_jsxs("div", { className: "card-header header", children: [_jsx("h3", { className: "recent-course-heading title", children: translate("app.home.recentCourseEvaluation.title") }), _jsx("div", { className: "base-font", children: translate("app.home.recentCourseEvaluation.desc") })] }), _jsxs("div", { className: "body", children: [state.showLoader && (_jsx(WidgetLoader, { loaderContainerClasses: "loader", loaderClasses: "content" })), state.courseEvaluationResultsError && (_jsx("div", { className: "widget-body", children: _jsx(ApiError, {}) })), !state.courseEvaluationResultsError && !state.showLoader && state.courseEvaluationResults && state.courseEvaluationResults.length > 0 && (_jsxs("div", { className: "widget-body", children: [_jsx("div", { className: "ai-banner", children: _jsx("p", { children: translate("app.home.recentCourseEvaluation.banner.text") }) }), state.courseEvaluationResults.map(function (result, index) { return (_jsxs("div", { className: "recent-course", onClick: function () { return navigateToExternalTask(result.url); }, onKeyDown: function (event) { return handleKeyPressFs(event, result.url); }, children: [_jsx("div", { className: "flex-row recent-course-evaluation-link", children: _jsx("a", { className: "recent-course-link", href: result.url, children: _jsxs("span", { className: "read-more", children: [result.courseCode, "\u2003\u2022\u2003", result.courseTitle] }) }) }), _jsx("div", { className: "recent-course-project-title", children: result.projectTitle })] }, "".concat(result.courseId, "-").concat(index))); })] })), !state.courseEvaluationResultsError && !state.showLoader && state.courseEvaluationResults && state.courseEvaluationResults.length == 0 && (_jsx("div", { className: "widget-body empty-state-course-evaluation", children: translate("app.home.recentCourseEvaluation.emptyState.text") }))] })] }) })));
}
